<!-- Support Widget Floating Trigger & Popup Container -->
<div class="support-widget-wrapper" [class.is-open]="isOpen">

  <!-- Popup Card Modal -->
  <div 
    class="support-popup-card" 
    [class.active]="isOpen"
    [class.chat-mode]="currentView === 'chat' || currentView === 'bot'"
    [class.user-list-mode]="currentView === 'user-list'"
    [class.faq-mode]="currentView === 'faq'"
    role="dialog"
    aria-label="Support dialog"
    aria-modal="false"
    (click)="$event.stopPropagation()">

    <!-- =========================================================================
         VIEW 1: SUPPORT MENU OPTIONS
         ========================================================================= -->
    <ng-container *ngIf="currentView === 'menu'">
      <!-- Card Header -->
      <div class="support-card-header">
        <div class="support-header-title">
          <span>Support</span>
        </div>
        <button 
          type="button" 
          class="support-close-btn" 
          (click)="closeWidget($event)" 
          aria-label="Close support menu"
          title="Close">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Card Options List -->
      <div class="support-card-body">
        <ul class="support-options-list">
          
          <li 
            *ngFor="let option of visibleSupportOptions" 
            class="support-option-item" 
            (click)="onSelectOption(option, $event)" 
            tabindex="0" 
            (keydown.enter)="onSelectOption(option, $event)">
            
            <!-- Icon variants based on iconType -->
            <div class="option-icon-wrapper" [ngClass]="'icon-' + option.iconType">
              
              <!-- Chat with Us Icon -->
              <svg *ngIf="option.iconType === 'chat'" class="option-svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                <line x1="8" y1="9" x2="16" y2="9"></line>
                <line x1="8" y1="13" x2="14" y2="13"></line>
              </svg>

              <!-- FAQ Icon -->
              <svg *ngIf="option.iconType === 'faq' || option.iconType === 'question'" class="option-svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>

              <!-- Chat with Users Icon -->
              <svg *ngIf="option.iconType === 'users'" class="option-svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>

            <span class="option-label">{{ option.title }}</span>
          </li>

        </ul>
      </div>
    </ng-container>

     <!-- =========================================================================
         VIEW 2B: SUPPORT ASSISTANT (RULE-BASED BOT, opened by "Chat with Us")
         ========================================================================= -->
    <ng-container *ngIf="currentView === 'bot'">
      <div class="chat-card-header">
        <div class="chat-header-left">
          <button type="button" class="chat-nav-back-btn" (click)="backAction($event)" title="Back" aria-label="Back">
            <svg class="header-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>
          <div class="chat-avatar-badge">
            <svg class="chat-avatar-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
          </div>
          <div class="chat-header-meta">
            <span class="chat-header-name">Support Assistant</span>
          </div>
        </div>
        <div class="chat-header-actions">
          <button type="button" class="chat-close-btn" (click)="closeWidget($event)" aria-label="Close chat" title="Close">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <app-support-bot
        [context]="botContext!"
        (handoff)="onBotHandoff($event)"
        (identity)="onBotIdentity($event)">
      </app-support-bot>
    </ng-container>


    <!-- =========================================================================
         VIEW 3: CHAT CONVERSATION VIEW
         ========================================================================= -->
    <ng-container *ngIf="currentView === 'chat'">
      <!-- Chat Green Header -->
      <div class="chat-card-header">
        <div class="chat-header-left">
          <button 
            type="button" 
            class="chat-nav-back-btn" 
            (click)="backAction($event)" 
            title="Back"
            aria-label="Back">
            <svg class="header-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>
          
          <div class="chat-avatar-badge" (click)="toggleUserInfoModal($event)" [class.clickable]="true" title="Click to view details">
            <svg class="chat-avatar-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>

          <div class="chat-header-meta clickable" (click)="toggleUserInfoModal($event)" title="Click to view details">
            <span class="chat-header-name">{{ activeChatTitle }}</span>
            <span *ngIf="activeChatSubtitle" class="chat-header-subtitle">{{ activeChatSubtitle }}</span>
          </div>
        </div>

        <!-- Header Actions: Info + (Reset for Chat with Us only) + Close -->
        <div class="chat-header-actions">

          <button 
            type="button" 
            class="chat-user-info-btn" 
            (click)="toggleUserInfoModal($event)" 
            title="User Details"
            aria-label="User Details">
            <svg class="info-svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
          </button>

          <!-- Clear Chat button ONLY rendered in Chat with Us (NOT for SSA or in Chat with Users) -->
          <button 
            *ngIf="!selectedConversation"
            type="button" 
            class="chat-clear-btn" 
            (click)="clearUserChat($event)" 
            title="Clear chat"
            aria-label="Clear chat">
            <svg class="clear-svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </button>

          <button 
            type="button" 
            class="chat-close-btn" 
            (click)="closeWidget($event)" 
            aria-label="Close chat"
            title="Close">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <!-- Chat Messages Scroll Area -->
      <div class="chat-messages-body" #chatMessagesContainer>
        
        <!-- Guest User Contact Info Overlay / Prompt Card -->
        <div *ngIf="showGuestInfoPrompt" class="guest-info-prompt-overlay" (click)="$event.stopPropagation()">
          <div class="guest-info-prompt-card">
            <div class="guest-info-header">
              <div class="guest-avatar-icon-wrapper">
                <svg class="guest-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <h3 class="guest-info-title">Welcome to Support!</h3>
              <p class="guest-info-subtitle">Please share your details so our team can reach you.</p>
            </div>

            <form class="guest-info-form" (submit)="submitGuestInfo($event)">
              <div class="guest-form-field">
                <label class="guest-field-label">Email Address <span class="required-star">*</span></label>
                <div class="guest-input-wrap">
                  <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  <input 
                    type="email" 
                    [(ngModel)]="guestEmail" 
                    name="guestEmail"
                    placeholder="e.g. name@example.com" 
                    class="guest-input"
                    required
                    autocomplete="email" />
                </div>
                <span *ngIf="guestFormErrors.email" class="guest-error-msg">{{ guestFormErrors.email }}</span>
              </div>

              <div class="guest-form-field">
                <label class="guest-field-label">Phone Number <span class="required-star">*</span></label>
                <div class="guest-input-wrap">
                  <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                  <input 
                    type="tel" 
                    [(ngModel)]="guestPhone" 
                    name="guestPhone"
                    placeholder="e.g. +91 9876543210" 
                    class="guest-input"
                    required
                    autocomplete="tel" />
                </div>
                <span *ngIf="guestFormErrors.phone" class="guest-error-msg">{{ guestFormErrors.phone }}</span>
              </div>

              <div class="guest-form-actions">
                <button type="button" class="btn-cancel-guest" (click)="cancelGuestPrompt($event)">Back</button>
                <button type="submit" class="btn-submit-guest">Continue to Chat</button>
              </div>
            </form>
          </div>
        </div>
        
        <div *ngIf="isLoadingMessages" class="chat-loading-state">
          <i class="fas fa-spinner fa-spin"></i>
          <span>Loading messages...</span>
        </div>

        <!-- Empty state when no messages yet -->
        <div *ngIf="!isLoadingMessages && (!messages || messages.length === 0)" class="chat-empty-state">
          <div class="empty-icon-pill">
            <svg class="empty-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              <line x1="8" y1="9" x2="16" y2="9"></line>
              <line x1="8" y1="13" x2="14" y2="13"></line>
            </svg>
          </div>
          <h4 class="empty-title">How can we help?</h4>
          <p class="empty-subtitle">Send a message below and we will assist you promptly.</p>
        </div>

        <div *ngFor="let msg of messages; trackBy: trackByMsg" class="chat-message-row" [ngClass]="'msg-' + msg.sender">
          
          <!-- Incoming Message Bubble -->
          <div *ngIf="msg.sender === 'incoming'" class="message-bubble-wrapper incoming-wrapper">
            <div class="message-bubble incoming-bubble">
              <p class="bubble-text">{{ msg.text }}</p>
            </div>
            <span *ngIf="msg.time" class="bubble-timestamp">{{ msg.time }}</span>
          </div>

          <!-- Outgoing Message Bubble -->
          <div *ngIf="msg.sender === 'outgoing'" class="message-bubble-wrapper outgoing-wrapper">
            <div class="message-bubble outgoing-bubble">
              <p class="bubble-text">{{ msg.text }}</p>
            </div>
            <span *ngIf="msg.time" class="bubble-timestamp">{{ msg.time }}</span>
          </div>

          <!-- System Message Pill (e.g., '1 unread message') -->
          <div *ngIf="msg.sender === 'system'" class="system-pill-wrapper">
            <span class="system-status-pill">{{ msg.text }}</span>
          </div>

        </div>
      </div>

      <!-- Chat Input Footer -->
      <div class="chat-input-footer">
        <form class="chat-input-container" (submit)="sendMessage($event)">
          <input 
            type="text" 
            [(ngModel)]="newMessageText" 
            name="newMessage"
            placeholder="Message" 
            class="chat-text-input" 
            autocomplete="off" />
          
          <button 
            type="submit" 
            class="btn-send-message" 
            [disabled]="!newMessageText.trim()"
            title="Send message"
            aria-label="Send message">
            <svg class="send-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </button>
        </form>
      </div>
    </ng-container>

    <!-- =========================================================================
         VIEW 4: FAQS ACCORDION & SEARCH VIEW (Matching Screenshot 2)
         ========================================================================= -->
    <ng-container *ngIf="currentView === 'faq'">
      <!-- FAQ Green Header -->
      <div class="faq-card-header">
        <div class="faq-header-left">
          <button 
            type="button" 
            class="faq-nav-back-btn" 
            (click)="backAction($event)" 
            title="Back to options"
            aria-label="Back">
            <svg class="header-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>
          
          <div class="faq-header-question-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
          </div>
        </div>

        <div class="faq-header-actions">
          <button 
            type="button" 
            class="faq-close-btn" 
            (click)="closeWidget($event)" 
            aria-label="Close FAQs"
            title="Close">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>

      <!-- FAQ Green Rounded Search Bar -->
      <div class="faq-search-section">
        <div class="faq-search-pill-wrapper">
          <svg class="faq-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input 
            type="text" 
            class="faq-search-input" 
            [(ngModel)]="faqSearchQuery" 
            placeholder="Search for your query"
            (click)="$event.stopPropagation()"
            aria-label="Search for your query" />
          <button 
            *ngIf="faqSearchQuery" 
            type="button" 
            class="faq-search-clear-btn" 
            (click)="clearFaqSearch($event)" 
            title="Clear search"
            aria-label="Clear search">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>

      <!-- FAQ Accordion List -->
      <div class="faq-accordion-body" (click)="$event.stopPropagation()">
        <!-- Loading State -->
        <div *ngIf="isLoadingFaqs" class="faq-loading-state">
          <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
          <span>Loading FAQs...</span>
        </div>

        <!-- Empty State -->
        <div *ngIf="!isLoadingFaqs && filteredFaqs.length === 0" class="faq-empty-state">
          <div class="faq-empty-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <p class="faq-empty-title">No matching questions found</p>
          <p class="faq-empty-desc">Try searching with other keywords or chat with our team.</p>
          <button type="button" class="faq-empty-chat-btn" (click)="switchToChatFromFaq($event)">
            <span>Chat with Us</span>
          </button>
        </div>

        <!-- FAQ Items List matching Screenshot 2 -->
        <div 
          *ngFor="let item of filteredFaqs; let i = index" 
          class="faq-row-entry" 
          [class.expanded]="activeFaqIndex === i">
          <div class="faq-row-title-bar" (click)="toggleFaqItem(i, $event)" tabindex="0" (keydown.enter)="toggleFaqItem(i, $event)">
            <span class="faq-row-question-text">{{ item.question }}</span>
            <span class="faq-row-chevron-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </span>
          </div>
          <div class="faq-row-content-body" *ngIf="activeFaqIndex === i">
            <p class="faq-row-answer-text">{{ item.answer }}</p>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- =========================================================================
         USER DETAILS POPUP / MODAL OVERLAY
         ========================================================================= -->
    <div *ngIf="showUserInfoModal && activeUserInfo" class="user-info-overlay" (click)="closeUserInfoModal($event)">
      <div class="user-info-card" (click)="$event.stopPropagation()">
        
        <div class="user-info-header">
          <div class="user-info-header-title">
            <svg class="info-header-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <span>User Details</span>
          </div>
          <button type="button" class="user-info-close-btn" (click)="closeUserInfoModal($event)" aria-label="Close user details">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="user-info-body">
          <div class="user-info-avatar-block">
            <div class="user-info-large-avatar">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <h4 class="user-info-main-name">{{ activeUserInfo.user_name }}</h4>
            <span class="user-info-role-badge">{{ activeUserInfo.role || 'User' }}</span>
          </div>

          <div class="user-info-details-list">
            <div class="user-info-item">
              <span class="item-label">User Name</span>
              <span class="item-value">{{ activeUserInfo.user_name }}</span>
            </div>

            <div class="user-info-item">
              <span class="item-label">Email</span>
              <span class="item-value">{{ activeUserInfo.user_email || '—' }}</span>
            </div>

            <div *ngIf="activeUserInfo.phone && activeUserInfo.phone !== '—'" class="user-info-item">
              <span class="item-label">Phone</span>
              <span class="item-value">{{ activeUserInfo.phone }}</span>
            </div>

            <div class="user-info-item">
              <span class="item-label">Organization Name</span>
              <span class="item-value">{{ activeUserInfo.org_name }}</span>
            </div>

            <div class="user-info-item">
              <span class="item-label">Organization ID</span>
              <span class="item-value">#{{ activeUserInfo.org_id }}</span>
            </div>

            <div class="user-info-item">
              <span class="item-label">Role</span>
              <span class="item-value">{{ activeUserInfo.role }}</span>
            </div>

            <div class="user-info-item">
              <span class="item-label">User ID</span>
              <span class="item-value">#{{ activeUserInfo.user_id }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

  <!-- Vertical Floating "Support" Tab Trigger Button -->
  <button 
    type="button" 
    class="support-trigger-tab" 
    [class.tab-active]="isOpen"
    [class.has-unread-msg]="hasUnreadAdminMessage && isLoggedIn"
    (click)="toggleWidget($event)"
    aria-label="Toggle Support Options"
    title="Support">
    <span class="tab-label">Support</span>
  </button>

</div>
